<template>
    <div class="grcform">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>

    <div class="grc_fullwidth_lane">
      <div class="grc_maincont_lane" style="padding-bottom: 20px;">

          <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:20px;">
              <i class="fas fa-exclamation-triangle" style="margin-right:10px;"></i>Az oldal nem található!
          </div>
          
      </div>
    </div>


    </div>
</template>

<script>

import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmNoPage',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmNoPage_",

          txtEmailCim: "",
          txtJelszo: "",
      }
  },
  model: {

  },  
  methods:{
    SetLang()
    {

    },

    SetControlToFocus(pNextComp)
    {
      this.$refs[pNextComp].SetFocus();
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
  }

}


</script>


<style scoped>

</style>